import '../styles/base.scss';

// mock data

// import { mockH1Data, mockC13Data, mockRealData } from './utils/mock';
// const $input = <HTMLInputElement>document.querySelector('#input');
// $input.innerHTML = mockH1Data;
// $input.innerHTML +=  '\n' + mockC13Data;
// $input.innerHTML = mockRealData;
// $input.innerHTML = `HRMS (ESI): m/z [M + Na]+ Calcd for C9H14BrN3Na, 266.20263; Found 266.0236.`;
// $input.innerHTML = `1H NMR (400 MHz, dmso) δ 2.22 (d, J = 2.0, 0.4 Hz, 1H).`;

import { AppComponent } from './appComponent';
AppComponent.getInstance;



// WEBPACK FOOTER //
// ../~/_tslint-loader@3.5.3@tslint-loader!./scripts/index.ts